/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DeleteMarkupResponse {
    getFixupPrototypeFunction() { return DeleteMarkupResponse.fixupPrototype; }

    static newInstance(model: Partial<DeleteMarkupResponse>): DeleteMarkupResponse {
        let obj = Object.assign(new DeleteMarkupResponse(), model);
        DeleteMarkupResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DeleteMarkupResponse>): DeleteMarkupResponse {
        if (!model) return null;
        return DeleteMarkupResponse.newInstance(<DeleteMarkupResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DeleteMarkupResponse) {
        if (!obj) return;

        models.DeleteMarkupResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DeleteMarkupResponse): boolean {
        Object.setPrototypeOf(obj, DeleteMarkupResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Deleted Rule name
     */
    name: string;

}
